export const LISTING_TYPE_HUMAN_NAME_MAP_TITLE = {
  JOB: getText('Job'),
  INTERNSHIP: getText('Internship'),
  VOLOP: getText('Volunteer Opportunity'),
  ORG: getText('Organization'),
  GRAD_PROGRAM: getText('Graduate Program'),
  USER: getText('User'),
};

export function getListingTypeHumanNameTitle(listing: {
  type: keyof typeof LISTING_TYPE_HUMAN_NAME_MAP_TITLE;
}) {
  return LISTING_TYPE_HUMAN_NAME_MAP_TITLE[listing.type];
}
